var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 215,
    viewBox: "0 0 225 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 7.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 32.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 57.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 82.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 107.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 132.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 157.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 182.5,
    r: 7.5,
    fill: "#AE9142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 207.5,
    r: 7.5,
    fill: "#AE9142"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.7a48de6e9b1e40c8f4a89cb7e54bff5b.svg";
export { ForwardRef as ReactComponent };